import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

export const useApiQuery = (key, fetchFn, options = {}) => {
  const keyArray = Array.isArray(key) ? key : [key];

  const hasInvalidKey = keyArray.some(
    k =>
      k === undefined ||
      k === null ||
      k === 'undefined' ||
      k === ''
  );

  return useQuery({
    queryKey: keyArray,
    queryFn: fetchFn,
    staleTime: 5 * 60 * 1000, // ✅ Increased from 1 min to 5 min
    gcTime: 10 * 60 * 1000, // ✅ Added garbage collection time
    retry: 1, // ✅ Reduced from 2 to 1
    retryDelay: 1000, // ✅ Wait 5 seconds before retry
    refetchOnWindowFocus: false, // ✅ Don't refetch on window focus
    refetchOnReconnect: false, // ✅ Don't refetch on reconnect
    refetchOnMount: "always", // ✅ Don't refetch on mount (critical!)
    enabled:
      options.enabled !== undefined
        ? options.enabled
        : !hasInvalidKey,
    ...options,
  });
};

export const useApiMutation = (mutationFn, options = {}) => {
 
  return useMutation({
    mutationFn,
    ...options,
    onSuccess: (data, variables, context) => {
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
  });
};

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  return (queryKey) => {
    queryClient.invalidateQueries({
      queryKey: Array.isArray(queryKey)
        ? queryKey
        : [queryKey],
    });
  };
};